import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAppContext } from '../context/AppContext';
import ApiService from '../services/apiService';

// Don't monitor on "Add an empty" page and debug camera page
const EXCLUDED_PAGES = ['/add-empty', '/debug-camera'];

/**
 * Console-only fluctuation warning - logs to browser console
 * No UI element, just background monitoring
 */
const FluctuationWarningConsole = () => {
  const location = useLocation();
  const { state } = useAppContext();

  useEffect(() => {
    if (state.settings.disableWeightMonitoring) {
      console.log('🔕 Fluctuation monitoring is disabled (admin setting)');
      return;
    }

    if (EXCLUDED_PAGES.includes(location.pathname)) {
      console.log('🔕 Fluctuation monitoring disabled on this page:', location.pathname);
      return;
    }

    console.log('🔔 Fluctuation monitoring enabled on:', location.pathname);

    const checkFluctuation = async () => {
      try {
        const response = await ApiService.checkFluctuation();

        if (response.success && response.is_fluctuating !== undefined) {
          if (response.is_fluctuating) {
            console.warn('⚠️  WEIGHT FLUCTUATING - Please wait for stable measurement or remove items');
          } else {
            console.log('✅ Weight stable');
          }
        }
      } catch (error) {
        // Silently ignore errors - don't spam console
      }
    };

    // Check fluctuation every 2 seconds
    const interval = setInterval(checkFluctuation, 2000);

    return () => clearInterval(interval);
  }, [location.pathname, state.settings.disableWeightMonitoring]);

  // No visual component - returns null
  return null;
};

export default FluctuationWarningConsole;
